var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.active,"color":_vm.color,"top":""},on:{"input":_vm.handleInput},scopedSlots:_vm._u([{key:"action",fn:function({ attrs }){return [_c('v-btn',_vm._b({attrs:{"color":"white","text":""},on:{"click":_vm.deactivate}},'v-btn',attrs,false),[_vm._v(" Close ")])]}}])},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }